module.exports = __webpack_public_path__ + "img/banner2_720.846c8a6a.jpg";